import {
    container,
    title,
    main,
    mainRaised,
    sidePageMainSection,
    sidePageBorderLine,
    mrAuto,
    whiteColor,
    mlAuto,
} from "assets/jss/material-kit-pro-react.js";

const orderProcessStageThreePageStyle = {
    main,
    mainRaised,
    sidePageMainSection,
    sidePageBorderLine,
    mrAuto,
    mlAuto,
    title,
    container: {
        ...container,
        zIndex: 2,

    },
    title1: {
        ...title,
        "&, & + h4": {
            color: whiteColor,
        },
    },
    textCenter: {
        textAlign: "center",
    },
    block: {
        color: "inherit",
        padding: "0.9375rem",
        fontWeight: "500",
        fontSize: "12px",
        textTransform: "uppercase",
        borderRadius: "3px",
        textDecoration: "none",
        position: "relative",
        display: "block",
    },
    inlineBlock: {
        display: "inline-block",
        padding: "0px",
        width: "auto",
    },
    list: {
        marginBottom: "0",
        padding: "0",
        marginTop: "0",
    },
    right: {
        padding: "15px 0",
        margin: "0",
        float: "right!important",
        display: "block",
    },

    left: {
        padding: "15px 0",
        float: "left!important",
        display: "block",
        margin: 0
    },
    icon: {
        width: "18px",
        height: "18px",
        top: "3px",
        position: "relative",
    },
    boxArea: {
        textAlign: "center!important",
        padding: "0px",
        width: "100%"
    },
    contactContent: {
        paddingBottom: "40px",
        paddingTop: "40px",
    },

    vicon: {
        fill: "green",
    },
    text: {
        fill: "white",
    },

    iconHolder: {
        padding: "35px 0px 0px 0px",
    },



};



export default orderProcessStageThreePageStyle;
